import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import { message } from 'antd';
import ProductApprovalListWrap from '../../views/product/list/approval/ProductApprovalListWrap';
import { appActions } from '../../store/modules/app';
import { productActions } from '../../store/modules/product';
import {
  PRODUCT_LIST_FILTER_OPTION_MODEL,
  PRODUCT_LIST_SEARCH_DATA_MODEL,
  PRODUCT_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/product/models';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';

class ProductApprovalListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { location, productList } = this.props;

    /**
     *  페이지에 처음 접근하는 것이 아닐 경우, 이전 검색조건으로 검색한다.
     */
    if (location.state) {
      this.getList({
        searchData: location.state.searchData,
        searchOption: location.state.searchOption,
        filterOption: location.state.filterOption,
        pagination: location.state.pagination,
        sortOption: location.state.sortOption,
        tagSearchList: location.state.tagSearchList,
      });
    } else {
      /**
       *  페이지에 처음 접근하면 초기화된 검색 조건으로 검색한다.
       */
      this.getList({
        searchData: PRODUCT_LIST_SEARCH_DATA_MODEL,
        searchOption: {
          /**
           *  실판매가
           */
          salesPrice: {
            startPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.salesPrice.startPrice,
            endPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.salesPrice.endPrice,
          },
          /**
           *  판매가
           */
          originPrice: {
            startPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.originPrice.startPrice,
            endPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.originPrice.endPrice,
          },
          /**
           *  할인된 판매가
           */
          discountedPrice: {
            startPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.discountedPrice.startPrice,
            endPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.discountedPrice.endPrice,
          },
          /**
           *  할인율
           */
          discountRate: {
            startRate: PRODUCT_LIST_SEARCH_DATA_MODEL.discountRate.startRate,
            endRate: PRODUCT_LIST_SEARCH_DATA_MODEL.discountRate.endRate,
          },
          /**
           *  할인가
           */
          discountPrice: {
            startPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.discountPrice.startPrice,
            endPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.discountPrice.endPrice,
          },
          /**
           *  할인설정 (원, %)
           */
          discountType: PRODUCT_LIST_SEARCH_DATA_MODEL.discountType.value,
          /**
           *  상품 카테고리
           */
          productCategory: PRODUCT_LIST_SEARCH_DATA_MODEL.productCategory,
          /**
           *  상품 태그
           */
          productTag: PRODUCT_LIST_SEARCH_DATA_MODEL.productTag,
        },
        filterOption: PRODUCT_LIST_FILTER_OPTION_MODEL,
        pagination: LIST_PAGINATION_MODEL,
        sortOption: PRODUCT_LIST_SORT_OPTION_MODEL,
        tagSearchList: productList.tagSearchList,
      });
    }
  };

  getList = (data) => {
    const { setData, getProductApprovalList, productList, history } = this.props;
    const { searchData, searchOption, filterOption, sortOption, pagination } = productList;

    /**
     *  서버로 요청
     */
    getProductApprovalList({
      searchOption,
      filterOption,
      sortOption,
      pagination,
      ...data,
    });

    /**
     *  새로고침 시에도 검색 UI 데이터를 유지해준다
     */
    if (data.searchData) {
      setData({
        path: ['productList', 'searchData'],
        value: data.searchData,
      });
    }

    /**
     *  history 에 검색조건을 저장한다
     */
    history.replace({
      ...history.location,
      state: {
        searchData,
        searchOption,
        filterOption,
        sortOption,
        pagination,
        ...data,
      },
    });
  };

  /**
   * 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getProductApprovalExcelDownload, pageName, productList, adminInfo } = this.props;

    if (!productList || !productList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getProductApprovalExcelDownload({
      email: adminInfo.email,
      searchOption: productList.searchOption,
      filterOption: productList.filterOption,
      sortOption: productList.sortOption,
      productPageName: pageName,
    });
  };

  render() {
    const { categorySelectList, productList, setData, getProductTagColumnTagList, getProductSubCategoryList } =
      this.props;

    return (
      <ProductApprovalListWrap
        categorySelectList={categorySelectList}
        productApprovalList={productList}
        setData={setData}
        getProductTagColumnTagList={getProductTagColumnTagList}
        getProductSubCategoryList={getProductSubCategoryList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    productList: state.product.productList,
    categorySelectList: state.product.categorySelectList,
  };
};

const mapDispatchToProps = {
  setData: productActions.setData,
  getProductApprovalList: productActions.getProductApprovalList,
  getProductApprovalExcelDownload: productActions.getProductApprovalExcelDownload,
  getProductTagColumnTagList: productActions.getProductTagColumnTagList,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductApprovalListContainer));
